import type { CameraMonitorState } from "@contracts/admin";

export const CAMERA_MONITOR_POLL_INTERVAL_MS = 12_000;

export const CAMERA_MONITOR_STATES: ReadonlyArray<{
  value: CameraMonitorState;
  label: string;
  tone: "success" | "warning" | "danger" | "neutral" | "info";
}> = [
  { value: "healthy", label: "Em dia", tone: "success" },
  { value: "delayed", label: "Atrasada", tone: "warning" },
  { value: "no_frame", label: "Sem frame", tone: "neutral" },
  { value: "capture_paused", label: "Captura pausada", tone: "neutral" },
  { value: "upload_paused", label: "Upload pausado", tone: "warning" },
  { value: "collector_offline", label: "Coletor offline", tone: "danger" },
];

export function cameraMonitorStatePresentation(state: CameraMonitorState) {
  return CAMERA_MONITOR_STATES.find((item) => item.value === state)
    ?? { value: state, label: state, tone: "neutral" as const };
}

export function cameraMonitorPollingInterval(visibilityState?: DocumentVisibilityState): number | false {
  return visibilityState === "visible" ? CAMERA_MONITOR_POLL_INTERVAL_MS : false;
}

export function currentCameraMonitorPollingInterval(): number | false {
  if (typeof document === "undefined") return false;
  return cameraMonitorPollingInterval(document.visibilityState);
}

export function frameReadQueryKey(frameId: string) {
  return ["frame-read-url", frameId] as const;
}
